import React, { useEffect, useState } from 'react';
import { useLocation} from 'react-router';
import { Grid, GridContainer } from 'src/shared/grid';
import { BreadCrumb } from 'src/shared/BreadCrumbs/BreadCrumb';
import { ROUTE_PATHS } from 'src/routes';

export const ReportDetailTab: React.FC = () =>{
  const location = useLocation(); 
  const [report, setReport] = useState<any>(location.state)

  useEffect(()=>{
    if(location?.state){
        setReport(location.state)
    }
  },[location.state]);

const buildBreadcrumbs = () => {
  if(location?.pathname?.includes('report/nfdrs')){
    return(   <BreadCrumb finalCrumb={report?.title} 
        prevCrumb={[
            { label: 'Fire Danger Report List', path: ROUTE_PATHS.pbiFireDanger, queries: {groupName: "All", groupId: null, areaId: 'All', areaName: 'All'} }, 
        ]} 
    /> )
  }
  else if(location?.pathname?.includes('report/weather')){
    return(   <BreadCrumb finalCrumb={report?.title} 
        prevCrumb={[
            { label: 'Weather List', path: ROUTE_PATHS.pbiWeather, queries: {groupName: "All", groupId: null, areaId: 'All', areaName: 'All'} }, 
        ]} 
    /> )  
  }
  else if(location?.pathname?.includes('report/station_information')){
    return(   <BreadCrumb finalCrumb={report?.title} 
        prevCrumb={[
            { label: 'Station Information List', path: ROUTE_PATHS.pbiStationInformation, queries: {groupName: "All", groupId: null, areaId: 'All', areaName: 'All'} }, 
        ]} 
    /> )  
  }
  else if(location?.pathname?.includes('report/advanced_analytics')){
    return(   <BreadCrumb finalCrumb={report?.title} 
        prevCrumb={[
            { label: 'Advanced Analytics List', path: ROUTE_PATHS.pbiAdvanced, queries: {groupName: "All", groupId: null, areaId: 'All', areaName: 'All'} }, 
        ]} 
    /> )  
  }
  else{
    return ""
  }

}

  //if there is nothing location.state we need to make a call to api when we integrate to get the information needed

  return (
        <GridContainer className="margin-top-6">
            {buildBreadcrumbs()}
            <Grid row gap="md">
                <Grid
                    desktop={{ col: 12 }}
                    className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3"
                >
                    <span className="font-sans-lg text-bold">{report?.title}</span>
                </Grid>
            </Grid>

            <Grid row gap="lg" id={'data-sets'} >
                <Grid desktop={{ col: 12 }} className="padding-bottom-2">
                    {report?.description}
                </Grid>
            </Grid>

            <Grid row gap="lg" id={'data-sets'} >
                <Grid desktop={{ col: 12 }} className="padding-bottom-2">
                    <iframe title={report?.title} width="1400" height="600" 
                      src={report?.url} 
                    allowFullScreen>

                    </iframe>

                </Grid>
            </Grid>
        </GridContainer>
    )
}
